<template>
    <div>
        <v-carousel
            v-if="!hideCarousel"
            class="appbar_carousel"
            touchless
            hide-delimiters
            height="333px"
            :show-arrows="false"
            cycle
        >
            <v-carousel-item
                v-for="(image, index) in images"
                :key="index"
                :src="image"
            />
        </v-carousel>
        <div
            v-if="!hideCarousel"
            class="endingscore"
        />
        
        
        <div
            v-if="!hideCarousel"
            class="gradient_wrapper"
        >
            <div class="appbar_white">
                <img
                    class="appbar_logo"
                    src="@/assets/az-logo.png"
                >
            </div>

            <!--<div class="appbar_gradient" />-->
        </div>
        
        
        <AZAppBar
            :menu-items="menuItems"
            :hide-app-logo="hideAppLogo"
            :title="title"
        />
    </div>
</template>

<script>
import AZAppBar from './AZAppBar.vue';

export default {
    name: "SliderAppBar",
    components: { AZAppBar },
    props: {
        menuItems: Array,
        hideCarousel: Boolean,
        hideAppLogo: Boolean,
        title: String,
        images: Array
    }
}
</script>

<style lang="scss">
$appbar_carousel_height: 200px;

@mixin carousel_height($height: 300px) {
  .appbar_carousel {
    height: $height !important;

    .v-window__container {
      height: $height !important;
    }

    .v-image {
      height: $height !important;
    }
  }

  .gradient_wrapper {
    height: $height !important;
  }
}

.gradient_wrapper {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.appbar_gradient {
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.65),
    rgba(255, 255, 255, 0)
  );
  width: 200px;
  height: 100%;
  display: inline-block;
}

.appbar_white {
  /*background-color: white;*/
  background-image: linear-gradient(
    to right,
    white,
    rgba(255, 255, 255, 0.65),
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0)
  );
  height: 100%;
  display: inline-block;
  padding: 0 150px 0 50px;
}

.appbar_logo {
  height: 100%;
  max-width: 250px;
  object-fit: contain;
}

.endingscore {
  background-color: $primary-color;
  height: 5px;
  width: 100%;
}

@media (min-width: map-get($breakpoints, sm)) {
  @include carousel_height(200px);
}

@media (min-width: map-get($breakpoints, md)) {
  @include carousel_height(200px);
}

@media (min-width: map-get($breakpoints, lg)) {
  @include carousel_height(250px);
}
</style>